import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { IPermitBase } from '@core/entities/permit/PermitBase'
import { permitsKeys } from '@core/react-query/features/permits'
import { useMutateQueryData } from '@core/react-query/hooks'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const getCreatePermitDraftMutationOptions = (
  queryClient: QueryClient,
) => {
  const { updateInfiniteQueryItem } = useMutateQueryData(queryClient)
  return {
    ...permitKeys.createDraft,
    onSuccess: (draft) => {
      updateInfiniteQueryItem(
        permitsKeys.drafts({
          organisationId: draft.template.organisationId,
          projectIds: [draft.projectId],
        }).queryKey,
        draft,
      )
    },
  }
}

/**
 * Creates a new permit draft.
 *
 * IMPORTANT: [LEGACY CLEANUP - Must happen BEFORE API deprecation]
 * The underlying mutation uses deprecated fields (`body`, `authorisedPersonInitiateBody`)
 * to upload files, then puts results in the wrappers. If the API removes these deprecated
 * fields before we migrate to using only the wrapper fields, permit draft creation will break.
 *
 * This mutation correctly handles PH vs AP flows conditionally.
 */
export const useCreatePermitDraft = () => {
  const queryClient = useQueryClient()
  return useMutation<
    IPermitBase,
    RequestErrorType,
    RequestTypes['createDraft']
  >(getCreatePermitDraftMutationOptions(queryClient))
}
